import { DefaultCountryStrategy } from '~/layouts/components/l10n/countries/DefaultCountryStrategy'
import { Routes } from '~/router/routes'

export class HUNCountryStrategy extends DefaultCountryStrategy {
  public readonly statOfficeReportsRoute: Routes | null = Routes.STATISTICS_REPORTS_INDEX

  isMenuPointDisabled(): boolean {
    return false
  }
}
